import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import memoizeOne from 'memoize-one';

import { RootState } from '../../../reducers';
import * as actionsJourney from '../../../actions/journey1';
import * as actionsCheckout from '../../../actions/checkout';
import * as actionsSujet from '../../../actions/sujet';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import { formConfig } from '../CreationOrder/formConfig';
import { Button, EButtonType, Input } from '@repo/apg-ui';
import { getIcon } from '../../../utils/mappings';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import '../CreationOrder/CreationOrder.scss';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';
import Tooltip from 'rc-tooltip';
import { defined } from '../../../utils/variableEvaluation';
import SpinnerV2 from '../../../components/SpinnerV2';
import { getDayName } from '../../../utils/date';
import { withRouter } from '../../../utils/withRouter';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { EValidationTestType } from '../../../utils/validationConfigs';
import { testsFailed } from '../../../utils/validationTests';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney2: any;
  actionsJourney: any;
  actionsCheckout: any;
  actionsSujet: any;
  campaignDetails: any;
  chosenproductionCompany: any;
  intl: any;
  loading: any;
  keycloakReady: any;
  locales: any;
  orderCompanies: any;
  orderCompaniesArray: Array<any>;
  setproductionCompany: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
}

type InputTypes =
  | 'phone'
  | 'street'
  | 'city'
  | 'gender'
  | 'firstname'
  | 'name'
  | 'email'
  | 'zipCode'
  | 'nr'
  | 'formats'
  | 'topics'
  | 'productionCompany'
  | 'checkboxControl';

type ErrorListTypes = { [key in InputTypes]: boolean };

const MAX_FILE_SIZE = 100000000; // 100MB

const DruckService = (props: Props) => {
  const [campaign, setCampaign] = React.useState<any>(null);

  const [stateData, setStateData] = React.useState<any>({
    productionCompany: null,
    addressOption: 0,
    firstname: '',
    name: '',
    street: '',
    nr: '',
    zipCode: '',
    city: '',
    email: '',
    phone: '',
    gender: '',
    formatsObj: {},
    upload: {},
    textarea: null,
    checkboxControl: false,
  });

  const [errorListInputs, setErrorListInputs] = React.useState<ErrorListTypes>({
    formats: false,
    topics: false,
    productionCompany: false,
    firstname: false,
    name: false,
    street: false,
    nr: false,
    zipCode: false,
    city: false,
    email: false,
    phone: false,
    gender: false,
    checkboxControl: true,
  });

  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const { keycloakReady, actionsSujet } = props;
    const campaignId = params.campaignId;

    if (keycloakReady) {
      actionsSujet
        .getCampaignDetails({ number: campaignId })
        .then((campaign) => {
          const formatsObj = {};

          if (campaign) {
            setCampaign(campaign);
            Array.from(new Set([...campaign.campaigndata.posters])).forEach(({ format, postercount }) => {
              formatsObj[format] = {
                value: false,
                format,
                number: postercount || 0,
              };
            });
          }

          setStateData({ ...stateData, formatsObj: formatsObj });
          actionsSujet.orderCompanies({ type: 1 });
        })
        .catch((err) => console.error(err));
    }
  }, []);

  // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
  //     if (prevState.formatsObj !== this.state.formatsObj) {
  //         this.setState({
  //             errorListInputs: { ...this.state.errorListInputs, topics: false },
  //         });
  //     }
  // }

  const postProductionOrder = async () => {
    const {
      userDataEC: { userInfo },
      actionsSujet: { postProductionOrder },
    } = props;

    let sujets = [];
    const formats = Object.keys(stateData.formatsObj).map((key) => {
      const fileName = stateData.formatsObj[key].fileName;

      stateData.upload[fileName] &&
        sujets.push({
          asseturn: stateData.upload[fileName].urn,
          count: stateData.formatsObj[key].number,
          format: key,
        });

      return stateData.formatsObj[key].format;
    });

    setErrorListInputs({
      ...errorListInputs,
      formats: formats.length < 1,
      topics: sujets.length < 1,
    });

    setErrorListInputs({
      ...errorListInputs,
      formats: formats.length < 1,
      topics: sujets.length < 1,
    });

    if (stateData.addressOption === 1) {
      if (await checkFormByDefault().then((res) => res)) {
        return;
      }
    } else {
      validationInput('productionCompany')();
      validationInput('checkboxControl')();
    }

    if (!stateData.productionCompany || formats.length < 1 || sujets.length < 1) {
      return;
    }

    const payload = {
      it21number: campaign.campaigndata.number,
      comment: stateData.textarea,
      formats: [...formats],
      sujets: [...sujets],
      productioncompanyid: stateData.productionCompany,
      otherresponsible: stateData.addressOption,
      title: userInfo.title,
      name: userInfo.name,
      firstname: userInfo.firstname,
      street: userInfo.address,
      zipcode: userInfo.zip,
      city: userInfo.city,
      phone: userInfo.phone,
      email: userInfo.email,
    };

    if (stateData.addressOption === 1) {
      payload['title'] =
        stateData.gender === 'Frau' ||
        stateData.gender === 'Madame' ||
        stateData.gender === 'Sig.ra' ||
        stateData.gender === 'Ms'
          ? 0
          : 1;
      payload['name'] = stateData.name;
      payload['firstname'] = stateData.firstname;
      payload['street'] = stateData.street;
      payload['zipcode'] = stateData.zipCode;
      payload['city'] = stateData.city;
      payload['phone'] = stateData.phone;
      payload['email'] = stateData.email;
    }

    postProductionOrder(payload).then((res) => {
      if (res && res.data) {
        navigate({
          pathname: `/campaign/${res.data.it21campaign}/production-order/${res.data.id}`,
        });
      }
    });
  };

  const postBasketCustomer = () => {
    const payload = {
      basket: props.userDataEC.chosenProposal.basket,
      name: stateData.name,
      city: stateData.city,
      company: 'test',
    };

    props.actionsCheckout.postBasketCustomer(payload);
  };

  const prepareAddressOptions = () => {
    return [
      {
        val: 0,
        text: <FormattedMessage id='ec.productionOrder.address1' defaultMessage='Aktuelle Kontaktadresse' />,
      },
      {
        val: 1,
        text: <FormattedMessage id='ec.productionOrder.otherAddress' defaultMessage='Andere Kontaktadresse angeben:' />,
      },
    ].map((addressText) => {
      return {
        label: addressText.text,
        type: 'radio',
        name: 'address',
        value: addressText.val,
        onChange: (name, _addressOption) => setStateData({ ...stateData, addressOption: _addressOption }),
      };
    });
  };

  const prepareOrderOptions = () => {
    const orderCompanies = props.orderCompaniesArray;

    if (orderCompanies && orderCompanies.length) {
      return orderCompanies.map((opt) => ({
        dropdownLabel: opt.label,
        id: opt.number,
      }));
    }
  };

  const validationInput =
    (inputName: InputTypes, validationTests: EValidationTestType[] = [EValidationTestType.hasValue]) =>
    () => {
      const value = stateData[inputName];
      const testsFailedArr: EValidationTestType[] = testsFailed(validationTests, value);

      setErrorListInputs({
        ...errorListInputs,
        [inputName]: testsFailedArr.length > 0,
      });
    };

  const isDisableButton = (addressOption: any, loading: any, errorListInputs: ErrorListTypes) => {
    if ((loading && loading.upload) || Object.keys(stateData.upload).length === 0) {
      return true;
    }

    if (Number(addressOption) === 1) {
      return Object.values(errorListInputs).join('-').includes('true');
    } else {
      const { productionCompany, topics, formats, checkboxControl } = errorListInputs;

      return `${productionCompany}-${topics}-${formats}-${checkboxControl}`.includes('true');
    }
  };

  const memoizedIsDisableButton = memoizeOne(isDisableButton);

  const checkFormByDefault = async () => {
    const inputs: InputTypes[] = [
      'phone',
      'street',
      'city',
      'gender',
      'firstname',
      'name',
      'email',
      'zipCode',
      'nr',
      'productionCompany',
      'checkboxControl',
    ];

    for (const input of inputs) {
      validationInput(input)();
    }

    return memoizedIsDisableButton(stateData.addressOption, props.loading, errorListInputs);
  };

  const isErrorClass = (inputName: InputTypes) => (errorListInputs[inputName] ? 'error-input' : '');

  const handleChangeFileInput = (formatKey: string) => (name, fileName, file, removeFile) => {
    if (name !== 'remove') {
      if (file.size > MAX_FILE_SIZE) {
        removeFile();
        return;
      }

      const myFormData = new FormData();

      myFormData.append('it21number', campaign?.campaigndata.number);
      myFormData.append('type', '2');
      myFormData.append('orderfile', file, file.name);
      myFormData.append('format', formatKey);

      props.actionsSujet.uploadFile(myFormData).then((res) => {
        if (res && res.data) {
          setStateData({
            ...stateData,
            formatsObj: {
              ...stateData.formatsObj,
              [formatKey]: { ...stateData.formatsObj[formatKey], fileName },
            },
            upload: {
              ...stateData.upload,
              [fileName]: {
                ...stateData.upload,
                urn: res.data.asseturn,
                url: res.data.url,
                size: res.data.filesize,
                type: res.data.mimetype,
                fileName: fileName,
                [formConfig.upload.file.name]: file,
              },
            },
          });
        } else {
          removeFile();
        }
      });
    } else {
      if (stateData.upload[fileName] && stateData.upload[fileName].urn) {
        props.actionsSujet.deleteUploadedFile({ urn: stateData.upload[fileName].urn }).then(() => {
          const newUploads = { ...stateData.upload };

          delete newUploads[fileName];
          setStateData({ ...stateData, upload: newUploads });
        });
      }
    }
  };

  const getContentTooltips = (format: string) => {
    const formatLowerCase = format.toLowerCase();
    const {
      intl: { formatMessage },
    } = props;

    const getContent = (format, formatTitle, pixels) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>
            <b style={{ color: 'red' }}>{formatTitle}:</b>
          </span>
          <span>
            <FormattedMessage
              id={`as.productionOrder.tooltips.DPI`}
              defaultMessage='<b>300 DPI</b> Auflösung'
              values={{ b: (value) => <b style={{ color: 'red' }}>{value}</b> }}
            />
          </span>
          <span>
            <FormattedMessage
              id={`as.productionOrder.tooltips.PDF`}
              defaultMessage='<b>PDF:</b> PDF/X-Druckvorlage in CMYK Farbmodus'
              values={{ b: (value) => <b style={{ color: 'red' }}>{value}</b> }}
            />
          </span>
          <span>
            <FormattedMessage
              id={`as.productionOrder.tooltips.JPG`}
              defaultMessage='<b>JPG:</b> {pixels} Pixel'
              values={{
                b: (value) => <b style={{ color: 'red' }}>{value}</b>,
                pixels,
              }}
            />
          </span>
        </div>
      );
    };

    const types = {
      f4: getContent(
        'f4',
        formatMessage({
          id: 'as.productionOrder.tooltips.f4Title',
          defaultMessage: 'F4 - Weltformat',
        }),
        '2537 x 3628',
      ),
      f12: getContent(
        'f4',
        formatMessage({
          id: 'as.productionOrder.tooltips.f12Title',
          defaultMessage: 'F12 - Breitformat',
        }),
        '7611 x 3628',
      ),
      f24: getContent(
        'f24',
        formatMessage({
          id: 'as.productionOrder.tooltips.f24Title',
          defaultMessage: 'F24 - Grossformat',
        }),
        '7611 x 7257',
      ),
      f200: getContent(
        'f4',
        formatMessage({
          id: 'as.productionOrder.tooltips.f200Title',
          defaultMessage: 'F200 - Cityformat',
        }),
        '3373 x 4819',
      ),
    };

    return formatLowerCase && formatLowerCase in types ? types[formatLowerCase] : null;
  };

  const {
    campaignDetails,
    intl,
    orderCompanies,
    userDataEC: { userInfo },
    loading,
  } = props;
  const preparedProductionCompany = prepareOrderOptions();
  const campaignId = params.campaignId;
  const product = campaignDetails ? campaignDetails[campaignId] : null;
  const addressOptions = prepareAddressOptions();

  return stateData.formatsObj && userInfo ? (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({
          id: 'ec.navigation.druckService',
          defaultMessage: 'Druck-Service',
        })}
      />
      <div className='container-fluid journey1 overflow-hidden p-0'>
        <div className='pageContainer'>
          <ErrorContainer journeyType='afterSales' />

          <div className='creationOrder production-order'>
            <div className='row justify-content-start'>
              <h3 className='col-8 mt-3 fw-bold mb-20'>
                <FormattedMessage id='as.productionOrder.plakatePrinting' defaultMessage='Druck-Service für Plakate' />
              </h3>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mb-20'>
                <FormattedMessage
                  id='as.productionOrder.printedEasily'
                  defaultMessage='Lassen Sie Ihr Plakat-Sujet bei Ihrer Wunschdruckerei einfach und unkompliziert drucken.'
                />
              </p>
              <p className='col-8 mb-20'>
                <FormattedMessage
                  id='as.productionOrder.selectAndPrint'
                  defaultMessage='Wählen Sie bitte als erstes die gewünschte Druckerei aus der Liste aus. Danach können Sie bei Punkt 2 Ihr druckfähiges Sujet hochladen und am Schluss dieser Seite Ihren Druckauftrag erteilen.'
                />
              </p>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mt-3 fw-bold mb-30'>
                <FormattedMessage
                  id='as.productionOrder.title'
                  defaultMessage='Druckauftrag zur Kampagne <a></a> kann bis spätestens am {w}, {d} erteilt werden.'
                  values={{
                    a: () => (
                      <a
                        rel='noopener noreferrer'
                        href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${product?.campaigndata.number}`}
                        target='_blank'
                      >
                        {product?.campaigndata.number}
                      </a>
                    ),
                    w: getDayName(product?.campaigndata.orderdeadline, intl.locale),
                    d: new Date(product?.campaigndata.orderdeadline).toLocaleDateString().split('/').join('.'),
                  }}
                />
              </p>

              <p className='col-12 fw-bold'>
                <FormattedMessage id='as.productionOrder.choosePrinter' defaultMessage='1. Druckerei wählen' />
              </p>
            </div>

            <div className='row justify-content-start mb-24'>
              {preparedProductionCompany && (
                <Input
                  id='produktionSagentur'
                  name=''
                  inputWrapperStyle={{
                    width: '300px',
                    marginLeft: 'auto',
                    marginTop: '50px',
                  }}
                  label='produktionSagentur'
                  clearable={true}
                  onSelected={(name, value) => setStateData({ ...stateData, productionCompany: value })}
                  value={
                    !!(orderCompanies && orderCompanies[stateData.productionCompany])
                      ? orderCompanies[stateData.productionCompany].label
                      : ''
                  }
                  selectOptions={preparedProductionCompany}
                  type='text'
                  inputWrapperClass={`col-4 ms-0 mb-4 align-self-start ${isErrorClass('productionCompany')}`}
                  onBlur={validationInput('productionCompany')}
                />
              )}

              {stateData.productionCompany ? (
                <div className='col-12 mb-60'>
                  <p className='m-0'>{orderCompanies[stateData.productionCompany]?.name}</p>
                  <p className='m-0'>{orderCompanies[stateData.productionCompany]?.street}</p>
                  <p className='mb-4'>
                    {orderCompanies[stateData.productionCompany]?.zipcode}{' '}
                    {orderCompanies[stateData.productionCompany]?.city}
                  </p>
                  <p className='m-0'>{orderCompanies[stateData.productionCompany]?.email}</p>
                  <p className='m-0'>{orderCompanies[stateData.productionCompany]?.phone}</p>
                </div>
              ) : (
                <div className='col-12 mb-60'>
                  <p className='m-0'>{product?.creationorder?.company.name}</p>
                  <p className='m-0'>{product?.creationorder?.company.street}</p>
                  <p className='mb-4'>
                    {product?.creationorder?.company.zipcode} {product?.creationorder?.company.city}
                  </p>
                  <p className='m-0'>{product?.creationorder?.company.email}</p>
                  <p className='m-0'>{product?.creationorder?.company.phone}</p>
                </div>
              )}
            </div>

            <div className='row justify-content-start'>
              <p className='col-12  mb-24 fw-bold'>
                <FormattedMessage id='as.productionOrder.second-title' defaultMessage='2. Sujet hochladen' />
              </p>
              <div className='col-12 d-flex flex-column p-4 bg-light ms-4 mb-24'>
                <p className='mb-2 fw-bold'>
                  <FormattedMessage id='as.productionOrder.messageWarning' defaultMessage='Wichtig' />
                </p>
                <p className='mb-24 fw-normal'>
                  <FormattedMessage
                    id='as.productionOrder.warningText'
                    defaultMessage='Hochgeladene Dateien werden auf Dateiformat und Grösse mit einer Toleranz von +/- 10%
überprüft. Eine Prüfung bezüglich Bildqualität/Auflösung wird <b></b> vorgenommen.'
                    values={{
                      b: () => (
                        <b>
                          <FormattedMessage id='as.productionOrder.messageWarningNight' defaultMessage='NIGHT' />
                        </b>
                      ),
                    }}
                  />
                </p>
              </div>

              <div className='d-flex flex-column format-druckservice col-12'>
                {stateData.formatsObj &&
                  Object.keys(stateData.formatsObj).map((formatKey) => {
                    const tooltip = getContentTooltips(stateData.formatsObj[formatKey].format);

                    return (
                      <div
                        key={`${stateData.formatsObj[formatKey].format}-${stateData.formatsObj[formatKey].number}`}
                        className='d-flex align-items-start mb-48 format-input customCheckbox'
                      >
                        <span className='d-flex flex-column me-48'>
                          <p className='fw-bold'>
                            <FormattedMessage
                              id='as.productionOrder.format'
                              defaultMessage='Format {format}'
                              values={{
                                format: stateData.formatsObj[formatKey].format,
                              }}
                            />
                          </p>

                          {getIcon(stateData.formatsObj[formatKey].format)}
                        </span>

                        <span className='d-flex flex-column me-48'>
                          <p className='fw-bold'>
                            <FormattedMessage id='as.productionOrder.topic' defaultMessage='Sujet' />

                            {tooltip && (
                              <Tooltip overlayClassName={'rc-tooltip-bg-white'} placement={'right'} overlay={tooltip}>
                                <InfoIcon className='ms-3' />
                              </Tooltip>
                            )}
                          </p>

                          <Input
                            isFocused
                            type='file'
                            isLoading={loading.upload}
                            maxLength={10}
                            inputWrapperClass='file-input file-input--small-rm-btn'
                            id={`id-${stateData.formatsObj[formatKey].format}-${stateData.formatsObj[formatKey].number}`}
                            name='file'
                            file={
                              stateData.formatsObj[formatKey] &&
                              stateData.upload[stateData.formatsObj[formatKey]['fileName']]
                                ? stateData.upload[stateData.formatsObj[formatKey]['fileName']]
                                : null
                            }
                            onChange={handleChangeFileInput(formatKey)}
                          />
                        </span>

                        <span className='d-flex flex-column flex-nowrap justify-content-center'>
                          <p className='fw-bold'>
                            <FormattedMessage id='as.productionOrder.numberPosters' defaultMessage='Anzahl Plakate' />

                            <Tooltip
                              overlayClassName={'rc-tooltip-bg-white'}
                              placement={'right'}
                              overlay={
                                <>
                                  <b>
                                    <FormattedMessage
                                      id='ec.components.packages.tooltipSujetTitle'
                                      defaultMessage='Berechnungsbeispiele Anzahl Plakate:'
                                    />
                                  </b>
                                  <br />
                                  <FormattedMessage
                                    id='ec.components.packages.tooltipSujetSubTitle'
                                    defaultMessage='Normal-/Nassplakate und L (Leuchter):'
                                  />
                                  <br />
                                  <FormattedMessage
                                    id='ec.components.packages.tooltipSujetText'
                                    defaultMessage='Anzahl Plakatstellen + 15% = Anzuliefernde Plakate (gerundet auf die nächst höhere Anzahl)'
                                  />
                                  <br />
                                  <FormattedMessage
                                    id='ec.components.packages.tooltipSujetSubTitleTwo'
                                    defaultMessage='LR (Leuchter/Roller - F12LR und F200LR):'
                                  />
                                  <br />
                                  <FormattedMessage
                                    id='ec.components.packages.tooltipSujetTextTwo'
                                    defaultMessage='Anzahl Wochen x Anzahl Plakatstellen + 15% = Anzuliefernde Plakate (gerundet auf die nächst höhere Anzahl).'
                                  />
                                </>
                              }
                            >
                              <InfoIcon className='ms-3' />
                            </Tooltip>
                          </p>

                          <span className='numeric d-flex align-items-center justify-content-center flex-nowrap'>
                            <input
                              type='text'
                              value={stateData.formatsObj[formatKey].number}
                              className='number-box'
                              id={stateData.formatsObj[formatKey].format + 'number'}
                            />
                          </span>
                        </span>
                      </div>
                    );
                  })}
              </div>

              {formConfig.upload.file.visible && <div className='col-12 col-sm-6' />}

              <p className='col-8 fw-bold'>
                <FormattedMessage id='as.productionOrder.bemerkungen' defaultMessage='Bemerkungen:' />
              </p>

              <div className='col-12 col-sm-6 textarea mb-24'>
                <Input
                  type='textarea'
                  label='label'
                  inputWrapperClass='textarea-input'
                  id='descriptionInput'
                  name='description'
                  value={stateData.textarea}
                  onChange={(name, value) => setStateData({ ...stateData, textarea: value })}
                >
                  <FormattedMessage id='as.productionOrder.comment' defaultMessage='Bemerkung' />
                </Input>
              </div>
            </div>

            <div className='row justify-content-start'>
              <p className='w-100 mt-24 mb-0 fw-bold'>
                <FormattedMessage
                  id='ec.productionOrder.contactDetails'
                  defaultMessage='3. Meine Kontaktdaten / Rechnungsadresse angeben'
                />
              </p>

              <div className='w-100'>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    postBasketCustomer();
                  }}
                >
                  <Input
                    readOnly={false}
                    forcedValue={stateData.addressOption}
                    radioOptions={addressOptions}
                    inputWrapperClass='horizontalRadios first-radio-narrow'
                  />

                  <div className='d-flex'>
                    <div className='w-40 ps-3'>
                      {userInfo && (
                        <div>
                          <p className='m-0'>{userInfo.title}</p>
                          <p className='m-0'>
                            {userInfo.firstname} {userInfo.lastname}
                          </p>
                          <p className='m-0'>{userInfo.address}</p>
                          <p className='mb-3'>
                            {userInfo.zip} {userInfo.city}
                          </p>
                          <p className='m-0'>{userInfo.email}</p>
                          <p className='m-0'>{userInfo.nr}</p>
                        </div>
                      )}
                    </div>

                    <div className='w-60 d-flex flex-wrap ms-3 marginCompensationx2 px-0'>
                      <Input
                        id='genderInput'
                        name='genderInput'
                        inputWrapperClass={`w-20 me-3 ${isErrorClass('gender')}`}
                        label='Language'
                        clearable={false}
                        onBlur={validationInput('gender')}
                        onSelected={(name, value) => setStateData({ ...stateData, gender: value })}
                        placeholder={props.intl.formatMessage({
                          id: 'ec.forms.genderHint',
                          defaultMessage: 'Geschlecht',
                        })}
                        value={stateData.gender}
                        selectOptions={[
                          {
                            dropdownLabel: props.intl.formatMessage({
                              id: 'ec.general.mrs',
                              defaultMessage: 'Frau',
                            }),
                            id: props.intl.formatMessage({
                              id: 'ec.general.mrs',
                              defaultMessage: 'Frau',
                            }),
                            value: props.intl.formatMessage({
                              id: 'ec.general.mrs',
                              defaultMessage: 'Frau',
                            }),
                          },
                          {
                            dropdownLabel: props.intl.formatMessage({
                              id: 'ec.general.mr',
                              defaultMessage: 'Herr',
                            }),
                            id: props.intl.formatMessage({
                              id: 'ec.general.mr',
                              defaultMessage: 'Herr',
                            }),
                            value: props.intl.formatMessage({
                              id: 'ec.general.mr',
                              defaultMessage: 'Herr',
                            }),
                          },
                        ]}
                        type='text'
                      />

                      <Input
                        value={stateData.firstname}
                        name={'vorname'}
                        required
                        onChange={(name, value) => setStateData({ ...stateData, firstname: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.vorname',
                          defaultMessage: 'Vorname',
                        })}
                        inputWrapperClass={`high w-30 me-3 ${isErrorClass('firstname')}`}
                        onBlur={validationInput('firstname')}
                      />

                      <Input
                        value={stateData.name}
                        required
                        name={'nr'}
                        onChange={(name, value) => setStateData({ ...stateData, name: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.name',
                          defaultMessage: 'Name',
                        })}
                        inputWrapperClass={`high w-30 ${isErrorClass('name')}`}
                        onBlur={validationInput('name')}
                      />

                      <Input
                        value={stateData.street}
                        required
                        name={'zipcode'}
                        onChange={(name, value) => setStateData({ ...stateData, street: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.street',
                          defaultMessage: 'Strasse',
                        })}
                        inputWrapperClass={`high w-30 me-2 no-end-padding-input ${isErrorClass('street')}`}
                        onBlur={validationInput('street')}
                      />

                      <Input
                        value={stateData.nr}
                        required
                        name={'nr'}
                        onChange={(name, value) => setStateData({ ...stateData, nr: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.nrHint',
                          defaultMessage: 'Nr.',
                        })}
                        inputWrapperClass={`high w-10 me-2 no-end-padding-input ${isErrorClass('nr')}`}
                        onBlur={validationInput('nr')}
                      />

                      <Input
                        value={stateData.zipCode}
                        required
                        name={'zipcode'}
                        onChange={(name, value) => setStateData({ ...stateData, zipCode: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.zipcodeHint',
                          defaultMessage: 'PLZ',
                        })}
                        inputWrapperClass={`high w-10 me-3 no-end-padding-input ${isErrorClass('zipCode')}`}
                        onBlur={validationInput('zipCode')}
                      />

                      <Input
                        value={stateData.city}
                        required
                        name={'city'}
                        onChange={(name, value) => setStateData({ ...stateData, city: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.ortHint',
                          defaultMessage: 'Ort',
                        })}
                        inputWrapperClass={`high w-30 ${isErrorClass('city')}`}
                        onBlur={validationInput('city')}
                      />

                      <Input
                        value={stateData.email}
                        required
                        name={'address'}
                        onChange={(name, value) => setStateData({ ...stateData, email: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.email',
                          defaultMessage: 'E-Mail',
                        })}
                        inputWrapperClass={`high w-51-7 me-3 ${isErrorClass('email')}`}
                        onBlur={validationInput('email')}
                      />

                      <Input
                        value={stateData.phone}
                        required
                        name={'city'}
                        onChange={(name, value) => setStateData({ ...stateData, phone: value })}
                        type='text'
                        placeholder={intl.formatMessage({
                          id: 'ec.forms.telephone',
                          defaultMessage: 'Telefon',
                        })}
                        inputWrapperClass={`high w-30 ${isErrorClass('phone')}`}
                        onBlur={validationInput('phone')}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 my-24 fw-bold'>
                4. <FormattedMessage id='ec.checkout.druckauftrageErteilen' defaultMessage='Druckauftrage erteilen' />
              </p>
              <div className='d-flex customCheckbox mb-4'>
                <input
                  id='abg'
                  name='abg'
                  type='checkbox'
                  className='mt-3'
                  checked={stateData.checkboxControl}
                  onChange={(e) => {
                    setStateData({ ...stateData, checkboxControl: e.target.checked });
                    setErrorListInputs({
                      ...errorListInputs,
                      checkboxControl: !e.target.checked,
                    });
                  }}
                />
                <label className='col-8 ms-0' htmlFor='abg'>
                  <FormattedMessage
                    defaultMessage='Hiermit bestatige ich, dass ich {user} die {company} mit dem Druck meiner Plakate zur Kampagne {campaignNo} beauftrage.'
                    id='ec.productionOrder.checkboxLabel'
                    values={{
                      user: `${props.userDataEC.userInfo.firstname} ${props.userDataEC.userInfo.lastname}`,
                      company:
                        defined(stateData.productionCompany) &&
                        props.orderCompanies &&
                        props.orderCompanies[stateData.productionCompany]
                          ? props.orderCompanies[stateData.productionCompany]['label']
                          : '?',
                      campaignNo: Object.keys(props.campaignDetails || {})[0],
                    }}
                  />
                  <br />
                  <br />

                  <FormattedMessage
                    defaultMessage='Wichtig: Das Gut zum Druck und die Verrechnung wird direkt zwischen dem Kunden und der Druckerei abgewickelt'
                    id='ec.productionOrder.checkboxLabelTwo'
                  />
                </label>
              </div>
            </div>
            <div className='row justify-content-start'>
              <div className='w-100 d-flex twoButtons'>
                <Button
                  onClick={() =>
                    navigate({
                      pathname: '/campaign/' + campaignId,
                    })
                  }
                  buttonType={EButtonType.InvertedPillMedium}
                >
                  <FormattedMessage id='ec.components.buttons.zuruck' defaultMessage='Zurück' />
                </Button>

                <Button
                  className='me-24 ms-3'
                  isLoading={loading['order']}
                  isDisabled={isDisableButton(stateData.addressOption, loading, errorListInputs)}
                  onClick={postProductionOrder}
                  buttonType={EButtonType.PillMedium}
                >
                  <FormattedMessage id='ec.components.buttons.next' defaultMessage='Bestätigen' />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <SpinnerV2 />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(actionsJourney as any, dispatch),
    actionsSujet: bindActionCreators(actionsSujet as any, dispatch),
    actionsCheckout: bindActionCreators(actionsCheckout as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(DruckService)));
